module.exports = __webpack_public_path__ + "img/waiting-on-photo@2x.961eec2e.png";